$(document).ready(function() {
    // スムーズスクロールの関数
    function smoothScroll(targetId) {
        var target = $('#' + targetId);
        if (target.length) {
            var position;
            if ($(window).width() <= 768) {
                position = target.offset().top - 103; // スマホ用オフセット
            } else {
                position = target.offset().top - 130; // PC用オフセット
            }
            $('html, body').animate({scrollTop: position}, 800, 'swing');
        }
    }

    // ページが読み込まれたときに、URLにハッシュが含まれていた場合、スクロールさせる
    $(window).on('load', function() {
        if (window.location.hash) {
            var targetId = window.location.hash.substring(1); // #を除いたID部分を取得
            smoothScroll(targetId); // ページ読み込み後にスムーズスクロール
        }
    });

    // リンククリック時の動作
    $('a[href*="#"]').click(function(e) {
        var href = $(this).attr('href'); // クリックされたリンクのhrefを取得
        var path = href.split('#')[0]; // hrefのパス部分を取得（#の前）
        var targetId = href.split('#')[1]; // hrefから#以降のID部分を取得

        // 現在のページのパスを取得
        var currentPath = window.location.pathname;

        // 1. 同じページ内リンクの場合
        if (path === "" || path === currentPath) {
            e.preventDefault(); // デフォルトのリンク動作をキャンセル
            smoothScroll(targetId); // スムーズスクロールを実行
        }

        // 2. 別ページへのリンクの場合
        else {
            // ページ遷移を許可し、その後アンカーへスクロール
            window.location.href = path + "#" + targetId;
        }
    });
});

// ドキュメントが読み込まれた後にコードを実行する
document.addEventListener('DOMContentLoaded', function() {
    // mobile-nav__link の要素を取得
    var navLinks = document.querySelectorAll('.mobile-nav__link');
    
    // js-drawer-close の要素を取得
    var drawerClose = document.querySelector('.js-drawer-close');

    // 各 mobile-nav__link にクリックイベントリスナーを追加
    navLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            // js-drawer-close をクリックしたことにする
            if (drawerClose) {
                drawerClose.click();
            }
        });
    });
});

